// minimum-order.js
document.addEventListener('DOMContentLoaded', function() {
  const MINIMUM_ORDER_VALUE = 30; // Mindestbestellwert in Euro
  
  // Funktion zum Auslesen des Warenkorb-Wertes via Shopify Cart API
  async function getCartTotal() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.total_price / 100; // Konvertierung von Cent in Euro
    } catch (error) {
      console.error('Fehler beim Laden des Warenkorbs:', error);
      return 0;
    }
  }

  // Funktion zum Anzeigen der Warnung
  function showMinimumOrderWarning() {
    if (document.getElementById('minimum-order-warning')) return;
    
    const warning = document.createElement('div');
    warning.id = 'minimum-order-warning';
       warning.style.backgroundColor = '#F8E5DD';
    warning.style.color = '#F26025';
    warning.style.padding = '12px';
    warning.style.margin = '10px 0';
    warning.style.borderRadius = '4px';
    warning.style.textAlign = 'center';
    warning.innerHTML = `Der Mindestbestellwert beträgt ${MINIMUM_ORDER_VALUE}€`;
    
    // Füge die Warnung an einer sichtbaren Stelle ein
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      cartForm.insertBefore(warning, cartForm.firstChild);
    }
  }

  // Funktion zum Entfernen der Warnung
  function removeWarning() {
    const warning = document.getElementById('minimum-order-warning');
    if (warning) {
      warning.remove();
    }
  }

  // Checkout-Button Handler
  async function handleCheckoutClick(e) {
    e.preventDefault(); // Verhindere zunächst den Standard-Checkout
    
    const total = await getCartTotal();
    if (total < MINIMUM_ORDER_VALUE) {
      showMinimumOrderWarning();
    } else {
      removeWarning();
      // Wenn der Mindestbestellwert erreicht ist, leite zum Checkout weiter
      window.location.href = '/checkout';
    }
  }

  // Funktion zum Prüfen und Aktualisieren der Warnung
  async function checkAndUpdateWarning() {
    const total = await getCartTotal();
    if (total < MINIMUM_ORDER_VALUE) {
      showMinimumOrderWarning();
    } else {
      removeWarning();
    }
  }

  // Event Listener für Checkout-Buttons
  const checkoutButtons = document.querySelectorAll('[name="checkout"], [href="/checkout"]');
  checkoutButtons.forEach(button => {
    button.addEventListener('click', handleCheckoutClick);
  });

  // Initialer Check beim Laden der Seite
  checkAndUpdateWarning();

  // Event Listener für Mengenänderungen
  document.addEventListener('change', async function(e) {
    if (e.target.matches('input[name="updates[]"]') || e.target.matches('input[name^="updates["]')) {
      // Warte kurz, bis Shopify den Cart aktualisiert hat
      setTimeout(checkAndUpdateWarning, 500);
    }
  });

  // Event Listener für Entfernen-Buttons
  document.addEventListener('click', async function(e) {
    if (e.target.matches('a[href^="/cart/change"]') || e.target.matches('button[data-remove-item]')) {
      // Warte kurz, bis Shopify den Cart aktualisiert hat
      setTimeout(checkAndUpdateWarning, 500);
    }
  });

  // Zusätzliche Event Listener für verschiedene Cart-Update-Events
  document.addEventListener('cart:updated', checkAndUpdateWarning);
  document.addEventListener('cart:refresh', checkAndUpdateWarning);
  document.addEventListener('cart:change', checkAndUpdateWarning);
});